var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M15.4081 20.96C14.7664 22.605 13.2031 23.6667 11.4414 23.6667H4.55807C2.78473 23.6667 1.23307 22.605 0.591399 20.96C-0.0502673 19.3033 0.393066 17.4717 1.69973 16.2817L6.42473 12H9.5864L14.2997 16.2817C15.6064 17.4717 16.0381 19.3033 15.4081 20.96Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.124 19.1628H5.87732C5.43398 19.1628 5.08398 18.8012 5.08398 18.3695C5.08398 17.9262 5.44565 17.5762 5.87732 17.5762H10.124C10.5673 17.5762 10.9173 17.9378 10.9173 18.3695C10.9173 18.8012 10.5557 19.1628 10.124 19.1628Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4084 3.03967C14.7668 1.39467 13.2034 0.333008 11.4418 0.333008H4.55844C2.79677 0.333008 1.23344 1.39467 0.591773 3.03967C-0.0382275 4.69634 0.393439 6.52801 1.71177 7.71801L6.42511 11.9997H9.58677L14.3001 7.71801C15.6068 6.52801 16.0384 4.69634 15.4084 3.03967ZM10.1234 6.43467H5.87677C5.43344 6.43467 5.08344 6.07301 5.08344 5.64134C5.08344 5.20967 5.44511 4.84801 5.87677 4.84801H10.1234C10.5668 4.84801 10.9168 5.20967 10.9168 5.64134C10.9168 6.07301 10.5551 6.43467 10.1234 6.43467Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMetric);
export default __webpack_public_path__ + "static/media/riskMetric.dcf8982546408eeebffbd23b74468484.svg";
export { ForwardRef as ReactComponent };